/**
 * STELLA-23: Limit enforced by the internal PromptSearchService only. AIMS may
 * accept longer prompts, so the frontend must use this to interpret a backend
 * validation response, never to block the request preemptively.
 */
export const PROMPT_SEARCH_MAX_LENGTH = 1000

export const PROMPT_TOO_LONG_API_ERROR =
  'Invalid prompt search query: String should have at most 1000 characters'

export const PROMPT_TOO_LONG_MESSAGE =
  'Your prompt is too long. Please keep it under 1,000 characters.'

/**
 * Maps the known backend length error to user-facing copy when it applies to
 * the current Prompt Search query.
 *
 * @param options.error - Backend error message
 * @param options.query - Query submitted to the backend
 * @param options.isPromptSearch - Whether the request used Prompt Search
 * @returns User-facing validation message, or null when the error does not match
 */
export const getPromptSearchValidationMessage = ({
  error,
  query,
  isPromptSearch,
}: {
  error: string | null | undefined
  query: string
  isPromptSearch: boolean
}): string | null =>
  isPromptSearch &&
  [...query].length > PROMPT_SEARCH_MAX_LENGTH &&
  error === PROMPT_TOO_LONG_API_ERROR
    ? PROMPT_TOO_LONG_MESSAGE
    : null
